import { Place } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React from "react";

function NoDataFound({
  resetFilterHadnler,
  setActiveFilterOption,
  setSelectedLocation,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60%",
        flexDirection: "column",
      }}
    >
      <Place style={{ fontSize: 70, color: "#ddd", marginBottom: 20 }} />
      <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Aucun magasin trouvé
      </Typography>
      <Typography variant="body2" sx={{ color: "#ddd" }}>
        Étendez votre recherche en
      </Typography>
      <Typography variant="body2" sx={{ color: "#ddd", marginBottom: 3 }}>
        désactivant certains filtres
      </Typography>
      <Button
        sx={{
          borderRadius: 5,
          color: "var(--primary)",
          borderColor: "var(--primary)",
        }}
        variant="outlined"
        onClick={() => {
          resetFilterHadnler();
          setActiveFilterOption([]);
          setSelectedLocation([]);
        }}
      >
        Effacer les filtres
      </Button>
    </Box>
  );
}

export default React.memo(NoDataFound);
